<template>
  <div class="tab_simcards">
    <div class="response_table" v-if="simcard_list.length > 0">
      <div class="header_simcards">
        <p class="title">
          {{ translate("simcard_devices.list") }}

          <span>
            ({{ translate("simcard_devices.online") }}:
            {{ count_simcard_online }})
          </span>
        </p>

        <div class="sims-filter" v-if="$store.getters.getPermissions.permissionGod === true">
          <div
              v-for="slot in slot_list"
              class="filter-item"
              :class="{ active: sims_slot === slot }"
              @click="change_sims_slot(slot)"
          >
            {{ slot }}
          </div>
        </div>

        <div class="sims-filter">
          <div class="filter-item" :class="{ active: sims_show === 'active' }" @click="change_sims_show('active')">
            {{ translate("simcard_devices.filter.active") }}
          </div>

          <div class="filter-item" :class="{ active: sims_show === 'in_device' }" @click="change_sims_show('in_device')">
            {{ translate("simcard_devices.filter.in_device") }}
          </div>

          <div class="filter-item" :class="{ active: sims_show === 'all' }" @click="change_sims_show('all')" v-if="$store.getters.getPermissions.permissionGod === true">
            {{ translate("simcard_devices.filter.all") }}
          </div>
        </div>

        <div class="buttons">
          <button
              v-if="$store.getters.getPermissions.permissionGod === true && Object.keys(traffic_info).length > 0"
              class="btn-info btn-fill btn-wd"
              @click="simcard_traffic_info()"
          >
            {{ translate("simcard_devices.traffic") }}
          </button>

          <button
              v-if="$store.getters.getPermissions.permissionGod === true"
              class="btn-success btn-fill btn-wd"
              @click="simcard_binding_modal()"
          >
            {{ simcard_binding.id ? translate("simcard_devices.edit") : translate("simcard_devices.bind") }}
          </button>
        </div>
      </div>
      <table>
        <thead style="flex: 0">
          <tr>
            <th
                scope="col"
                @click="change_filter('slot')"
                class="slot pointer"
                :class="{ selected: filter_type === 'slot' }"
            >
              {{ translate("simcard_devices.slot") }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              ></i>
            </th>

            <th scope="col" class="status">
              {{ translate("simcard_devices.status") }}
            </th>
<!--            <th scope="col" class="active">-->
<!--              {{ translate("simcard_devices.in_device") }}-->
<!--            </th>-->

            <th scope="col" class="w10per">
              {{ translate("simcard_devices.mno") }}
            </th>
            <th scope="col" class="w10per">
              {{ translate("simcard_devices.imsi") }}
            </th>
            <th scope="col" class="w15per">
              {{ translate("simcard_devices.iccid") }}
              <i class="mdi mdi-content-copy pointer" @click.stop.prevent="copy_iccid" />
            </th>
            <th
              scope="col"
              @click="change_filter('ts_sync')"
              class="pointer ts_sync"
              :class="{ selected: filter_type === 'ts_sync' }"
            >
              Sync
              <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
              ></i>
            </th>

            <th scope="col" v-if="$store.getters.getPermissions.permissionGod === true">
              {{ translate("simcard_devices.profile") }}
            </th>

            <th scope="col" class="w15per" v-if="$store.getters.getPermissions.permissionGod === true">
              {{ translate("simcard_devices.traffic") }}
            </th>

            <th scope="col" class="w50" v-if="$store.getters.getPermissions.permissionGod === true">

            </th>

            <th scope="col" class="binding" v-if="!hide_config">
              {{ translate("simcard_devices.configuration") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(sim, key) in sims_list"
            :key="key"
            class="link pointer"
            :class="{ our_sim: sim.simcard_profile !== null }"
          >
            <td
                class="slot"
                :data-label="translate('simcard_devices.slot')"
                :title="sim.power ? 'power: on' : 'power: off'"
                :class="sim.power ? 'power_on' : 'power_off'"
            >
              {{ sim.slot }}
            </td>

            <td
              class="status"
              :data-label="translate('simcard_devices.status')"
              :title="sim_state_title(sim.sim_state)"
            >
              <div class="status__wrap">
                <span
                    v-if="sim.is_in_another_device === true"
                    class="mdi mdi-swap-horizontal fz16"
                    :title="translate('simcard_devices.is_in_another_device')"
                />
                <SimState
                    :sim_state="sim.sim_state"
                />

                <SignalQualityIndicator
                    v-if="sim.sim_state && Object.keys(sim.sim_state).length > 0 && sim.active === 1"
                    :data="sim.sim_state"
                />
              </div>

            </td>

            <td
                :data-label="translate('simcard_devices.mno')"
                :title="sim_state_title(sim.sim_state)"
                class="w10per"
            >
              <a
                  v-if="sim.simcard_profile?.mno_link && $store.getters.getPermissions.permissionGod === true"
                  :href="sim.simcard_profile.mno_link"
                  target="_blank"
                  class="pointer"
              >
                {{ sim.mno }}
              </a>
              <template v-else>
                {{ sim.mno }}
              </template>
            </td>

            <td
              data-label="imsi"
              class="cell w10per"
              :title="sim_state_title(sim.sim_state)"
            >
              <router-link :to="'/simcard_devices/' + sim.imsi" class="cell-link">
                {{ sim.imsi }}
              </router-link>
            </td>
            <td
              data-label="iccid"
              class="cell w15per"
              @click.prevent.stop=""
              :title="sim_state_title(sim.sim_state)"
            >
              <router-link :to="'/simcard_devices/' + sim.imsi" class="cell-link">
                {{ sim.iccid }}
                <i
                    v-if="$store.getters.getPermissions.permissionGod === true"
                    class="copy mdi mdi-content-copy"
                    @click.stop.prevent="copy_text(sim.iccid)"
                />
              </router-link>

            </td>
            <td
              class="ts_sync"
              data-label="ts"
              :title="sim_state_title(sim.sim_state)"
            >
              <router-link :to="'/simcard_devices/' + sim.imsi" class="cell-link">
                {{ get_date_with_check(sim.ts_sync) }}
              </router-link>
            </td>

            <td
                :data-label="translate('simcard_devices.profile')"
                v-if="$store.getters.getPermissions.permissionGod === true"
                class="profile"
                :title="show_title_simcard(sim)"
            >
              <router-link
                  :to="'/simcard_profile/' + sim.simcard_profile.id"
                  class="cell-link"
                  v-if="sim.simcard_profile"
              >
                <span
                  v-if="sim.simcard_profile"
                  class="badge"
                  :class="global_status_color(+sim.simcard_profile.status)"
                >
                  {{ translate(global_status_text(+sim.simcard_profile.status)) }}
                </span>

                <span
                    v-if="sim.simcard_profile_options?.simcard_operator_apn_id"
                    class="badge green"
                    :title="get_apn_title(sim.simcard_profile_options?.simcard_operator_apn_id)">
                  APN
                </span>

                <span
                    v-if="sim.simcard_profile_options?.esim"
                    class="badge green">
                  ESIM
                </span>

                <span
                    v-if="sim.simcard_profile_options?.oper_account_is_bucket === true"
                    class="badge green"
                    title="Котловой счет"
                >
                  <span class="mdi mdi-sitemap boiler" />
                </span>
              </router-link>
            </td>

            <td
                class="traffic w15per"
                :data-label="translate('simcard_devices.traffic')"
                v-if="$store.getters.getPermissions.permissionGod === true"
            >
              <p class="d-flex justify-content-sb">
                <span
                    class="rest"
                    :class="def_rest(sim.simcard_profile_options?.traffic)"
                    :title="traffic_title(sim.simcard_profile_options?.traffic)"
                >
                  {{ sim.simcard_profile_options?.traffic?.rest != null ? `${sim.simcard_profile_options.traffic.rest} / ${sim.simcard_profile_options.traffic.limit} Gb` : ''}}
                </span>
                <span v-if="sim.traffic?.summary">
                  {{ sim.traffic.summary }}
                </span>
              </p>
            </td>

            <td class="w50" v-if="$store.getters.getPermissions.permissionGod === true">
              <span class="mdi mdi-lock" v-if="sim.bind" />
            </td>

            <td
              class="binding"
              :data-label="translate('simcard_devices.configuration')"
              :title="icon_title(sim)"
              v-if="!hide_config"
            >
              <span
                v-for="(param, param_key) in params_list"
                :key="param_key"
              >
                <span
                    v-if="sim[param_key]"
                    class="mdi fz16"
                    :class="param.class"
                />
                <span
                    v-if="param_key === 'apn' && sim[param_key]"
                    :title="show_simcard_apn(sim)"
                    :class="{ 'text-danger': apn_mismatch(sim) }"
                >
                  APN
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import SimcardBinding from "./Binding/Index.vue";
import SimcardTraffic from "./Modal/Traffic.vue";
import SimState from "components/UIComponents/SimState/Index.vue";
import SignalQualityIndicator from "components/UIComponents/SignalQualityIndicator/SignalQualityIndicator.vue";

export default {
  name: "SimcardList",
  components: {
    SimState,
    SignalQualityIndicator
  },
  props: ["device_id", "device_fid", "simcard_list", "simcard_binding", "network_settings", "status", "params_list", "traffic_info"],
  data() {
    return {
      filter_asc: "desc",
      filter_type: "",
      sims_show: Boolean(!this.status) ? "in_device" : "active",
      sims_slot: "",
    };
  },
  computed: {
    hide_config(){
      return this.sims_list.every(item => item.clear_params === true);
    },
    slot_list(){
      return [...new Set(
        this.simcard_list
            .map(item => {
              if (!item || item.slot == null) {
                return '';
              }
              return String(item.slot).trim().toUpperCase();
            })
            .filter(Boolean)
        )
      ];
    },
    sims_list() {
      let list = [...this.simcard_list]
      if (this.sims_slot !== "") {
        list = list.filter(simcard => String(simcard.slot || '').toLowerCase() === this.sims_slot.toLowerCase())
      } else if (this.sims_show === "active") {
        list = list.filter(simcard => simcard.active === 1)
      } else if (this.sims_show === "in_device") {
        list = list.filter(simcard => simcard.is_last_in_slot && simcard.slot)
      }
      return list.sort(this.compareNumbers)
    },

    count_simcard_online() {
      let count_online = 0;
      if (this.simcard_list) {
        for (let simcard of this.simcard_list) {
          if (simcard.active === 1) {
            count_online += 1;
          }
        }
      }
      return count_online;
    },
  },
  methods: {
    traffic_title(traffic) {
      const title = this.translate('simcard_devices.rem_traffic_in_package', {
        rest: traffic?.rest,
        limit: traffic?.limit
      })
      const updated = Number(traffic?.ts_update)
      if (!Number.isFinite(updated) || updated <= 0) return title
      const seconds = Math.max(0, Math.floor(Date.now() / 1000 - updated))
      const unit = seconds >= 86400 ? 'day' : seconds >= 3600 ? 'hour' : seconds >= 60 ? 'minute' : 'second'
      const divisor = { day: 86400, hour: 3600, minute: 60, second: 1 }
      const elapsed = new Intl.RelativeTimeFormat(this.$root.language === 'ru' ? 'ru' : 'en', { numeric: 'always' })
          .format(-Math.floor(seconds / divisor[unit]), unit)
      return `${title}\n${elapsed}`
    },
    change_sims_show(mode) {
      this.sims_show = mode
      this.sims_slot = ""
      if (mode !== "all") this.filter_type = ""
    },
    show_simcard_apn(sim){
      return this.network_settings?.simcards?.apn?.[sim.slot?.toLowerCase()] || ""
    },
    apn_mismatch(sim) {
      if (this.$store.getters.getPermissions.permissionGod !== true) return false
      const profile_apn = this.get_apn_title(sim.simcard_profile_options?.simcard_operator_apn_id)
      if (!profile_apn) return false
      return profile_apn.trim().toLowerCase() !== this.show_simcard_apn(sim).trim().toLowerCase()
    },
    def_rest(traffic){
      if (traffic && traffic.rest != null){
        if (Number(Number(traffic.rest) / Number(traffic.limit)) < 0.1) return "red"
        else if (Number(Number(traffic.rest) / Number(traffic.limit)) < 0.25) return "orange"
        else return "green"
      }
      return ""
    },
    change_sims_slot(change_slot){
      this.sims_slot = (this.sims_slot === change_slot) ? "" : change_slot
      if (this.sims_slot) this.sims_show = "all"
    },
    get_apn_title(apn_id){
      const operator_apn = this.$store.getters.getSimcardOperatorApn.find((apn) => {
        if (apn_id === apn.id) return apn
      })
      return operator_apn ? operator_apn.title : ""
    },
    copy_iccid(){
      let string = this.sims_list.map(sim => sim.iccid).filter(Boolean).join("\n")
      this.copy_to_clipboard(string);
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    copy_text(text){
      if (this.$store.getters.getPermissions.permissionGod === true){
        this.copy_to_clipboard(text);
        this.global_notify("info", this.translate("clipboard.value_save_buffer"));
      }
    },
    icon_title(sim){
      let title = ""
      Object.keys(this.params_list).forEach((param) => {
        if (sim[param]){
          title += this.params_list[param].label + "\n"
        }
      })
      return title
    },
    simcard_binding_modal() {
      let t = this.$createElement(SimcardBinding, {
        props: {
          device_id: this.device_id,
          simcard_binding: this.simcard_binding,
          simcard_list: this.simcard_list,
        },
        on: {
          close: () => {
            this.$modal.hide("simcard_binding");
          },
          update: () => {
            this.$emit("update_simcard_binding");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            width: 1000,
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "simcard_binding",
          }
      );
    },

    simcard_traffic_info() {
      let t = this.$createElement(SimcardTraffic, {
        props: {
          traffic_info: this.traffic_info,
        },
        on: {
          close: () => {
            this.$modal.hide("traffic_info");
          },
          update: () => {
            this.$emit("update_simcard_binding");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "traffic_info",
          }
      );
    },

    get_date_with_check(ts) {
      const currentDate = new Date();
      const timestamp = currentDate.getTime() / 1000;
      if (timestamp < ts + 60) {
        return "now";
      }
      return this.get_date_short(ts);
    },
    show_title_simcard(simcard){
      let string = ""
      if (simcard.simcard_profile){
        simcard.msisdn ? string += `msisdn: ${simcard.msisdn}\n` : ''
        simcard.imsi ? string += `imsi: ${simcard.imsi}\n` : ''
        simcard.iccid ? string += `iccid: ${simcard.iccid}\n` : ''
        simcard.simcard_profile.oper_account ? string += `oper_account: ${simcard.simcard_profile.oper_account}\n` : ''
        simcard.simcard_profile.ap_date ? string += `ap_date: ${simcard.simcard_profile.ap_date}\n` : ''
        simcard.simcard_profile.ap_sum ? string += `ap_sum: ${simcard.simcard_profile.ap_sum}\n` : ''
        simcard.simcard_profile.ts_update ? string += `ts_update: ${this.get_date(simcard.simcard_profile.ts_update)}\n` : ''
        simcard.simcard_profile.ts_status_update ? string += `ts_status_update: ${this.get_date(simcard.simcard_profile.ts_status_update)}\n` : ''
        simcard.simcard_profile.tariff ? string += `tariff: ${simcard.simcard_profile.tariff}\n` : ''
        simcard.simcard_profile_options?.simcard_operator_apn_id ? string += `APN: ${this.get_apn_title(simcard.simcard_profile_options.simcard_operator_apn_id)}\n` : ''

        if (simcard.simcard_profile.traffic){
          let traffic = simcard.simcard_profile.traffic
          let value = this.traffic_balance(traffic).traffic
          value += ' ' + this.translate("simcard_devices.out_of") + ' ' + (traffic.limit > 1024*5 ? Math.round(traffic.limit/1024)+' GB' : traffic.limit+' MB')
          if (simcard.simcard_profile.traffic.ts_update){
            value += '. Обновлено ' + this.get_date(simcard.simcard_profile.traffic.ts_update)
          }
          string += value;
        }
      }
      return string
    },
  },
};
</script>
<style lang='scss' scoped>
.tabs-component-panel .tab_simcards {
  .header_simcards {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-size: 12px;
      line-height: 120%;
      font-weight: bold;
      margin-bottom: 0;
      span {
        font-weight: normal;
        font-size: 12px;
        color: #9a9a9a;
      }
    }
    .switch {
      font-size: 12px;
      line-height: 120%;
    }
    .buttons{
      button{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }

    .sims-filter {
      display: flex;
      align-items: center;
      border: 1px solid #eaeaea;
      border-radius: 4px;

      .filter-item {
        padding: 4px 10px;
        cursor: pointer;
        user-select: none;
        transition: background 0.2s;

        &:first-child{
          border-radius: 4px 0 0 4px;
        }

        &:last-child{
          border-radius: 0 4px 4px 0;
        }

        &:hover {
          background: #41b88330;
        }

        &.active {
          background: #41b88330;
          color: #252422;
        }
      }
    }
  }
  .response_table {
    padding: 0;
    table {
      .our_sim {
        td{
          background-color: #41b88330;
        }
      }
      .status {
        width: 70px;
        vertical-align: middle;
        position: relative;
        &__wrap{
          display: flex;
          align-items: center;
        }
      }
      .slot {
        width: 50px;
        &.power_off{
          background-color: #b8414130;
        }
      }
      .binding {
        width: 75px;
      }
      .profile{
        .cell-link{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: nowrap;
          gap: 5px;
          .badge{
            padding: 3px 4px;
            font-size: 11px;
          }
        }
      }
      .ts_sync{
        width: 100px
      }
      tbody {
        .link {
          color: black;
        }
      }
      p{
        font-size: 10px;
        margin-bottom: 0;
      }
      .boiler{
        font-size: 14px;
      }
      .rest{
        font-weight: bold;
        &.green{
          color: #1db328;
        }
        &.red {
          color: #fd3e3e;
        }
        &.orange {
          color: #f3bb45;
        }
      }
    }
    table tr {
      background-color: white;
      &:hover {
        background-color: #f1f1f1;
      }
      .cell{
        padding: 0;
        &-link{
          display: block;
          width: 100%;
          height: 100%;
          color: #252422;
        }
      }
    }
    &:first-child {
      margin-bottom: 10px;
    }
  }
}
.pointer {
  cursor: pointer;
}
</style>
